var __WEBPACK_NAMESPACE_OBJECT__ = require("socket.io-client");